import { OfflineOrderRepeatEffect } from './offline-order-repeat.effect';
import { OnlineOrderDetailsEffect } from './online-order-details.effect';
import { OnlineOrderRepeatEffect } from './online-order-repeat.effect';
import { OnlineOrdersListEffect } from './online-orders-list.effect';
import { OrderInvoicePaymentEffect } from './order-invoice-payment.effect';
import { RepeatOrderSuccessEffect } from './repeat-order-success.effect';

export const effects: any[] = [
  OnlineOrderDetailsEffect,
  OnlineOrderRepeatEffect,
  OnlineOrdersListEffect,
  OrderInvoicePaymentEffect,
  OfflineOrderRepeatEffect,
  RepeatOrderSuccessEffect,
];
